/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface PostCorporationsCorporationIdAssetsLocationsNotFound
 */
export interface PostCorporationsCorporationIdAssetsLocationsNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof PostCorporationsCorporationIdAssetsLocationsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the PostCorporationsCorporationIdAssetsLocationsNotFound interface.
 */
export function instanceOfPostCorporationsCorporationIdAssetsLocationsNotFound(value: object): value is PostCorporationsCorporationIdAssetsLocationsNotFound {
    return true;
}

export function PostCorporationsCorporationIdAssetsLocationsNotFoundFromJSON(json: any): PostCorporationsCorporationIdAssetsLocationsNotFound {
    return PostCorporationsCorporationIdAssetsLocationsNotFoundFromJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsLocationsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCorporationsCorporationIdAssetsLocationsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostCorporationsCorporationIdAssetsLocationsNotFoundToJSON(json: any): PostCorporationsCorporationIdAssetsLocationsNotFound {
    return PostCorporationsCorporationIdAssetsLocationsNotFoundToJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsLocationsNotFoundToJSONTyped(value?: PostCorporationsCorporationIdAssetsLocationsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

